import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import HomePage from "../pages/Home";
import Ranking from "../pages/Ranking";

class Navigator extends Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route component={Ranking} />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default Navigator;
